import Fraction from '@/components/ui/fraction';
import { type AssignedTask, TaskV2 } from '@/models/registry';
import { observer } from 'mobx-react-lite';
import useTasksStats, { useTasksStatsV2 } from './hooks/use-tasks-stats';

const TasksFraction = ({
  assignedTasks,
  className,
}: {
  assignedTasks: AssignedTask[];
  className?: string;
}) => {
  const { numberOfTasksDone } = useTasksStats(assignedTasks);

  return (
    <Fraction
      numerator={numberOfTasksDone}
      denominator={assignedTasks.length}
      className={className}
    />
  );
};

export const TasksFractionV2 = observer(
  ({
    assignedTasks,
    className,
  }: {
    assignedTasks: TaskV2[];
    className?: string;
  }) => {
    const { numberOfTasksDone } = useTasksStatsV2(assignedTasks);

    return (
      <Fraction
        numerator={numberOfTasksDone}
        denominator={assignedTasks.length}
        className={className}
      />
    );
  },
);

export default TasksFraction;
